import Axios from 'axios'

export default {
  loadUsers (Vue) {
    Vue.$data.rankLoading = true
    Axios.get(`${Vue.$apiUrl}/champions`).then((res) => {
      Vue.$data.rankLoading = false
      if (res.data) {
        Vue.$data.champions = res.data
      }
    }).catch((err) => {
      Vue.$data.rankLoading = false
      Vue.$notice['error']({
        title: err.response.statusText,
        description: err.response.data
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/champions/index.js